let foo = x => "foo " + x;
console.log(foo("bar"));